export class ApiService {
  readonly baseUri: string = '/api/f/';
  readonly baseUriNoAuthKey: string = '/api/b/';
}
